import { render, staticRenderFns } from "./carCreateFeeList.vue?vue&type=template&id=5b8d5c47&scoped=true"
import script from "./carCreateFeeList.vue?vue&type=script&lang=js"
export * from "./carCreateFeeList.vue?vue&type=script&lang=js"
import style0 from "./carCreateFeeList.vue?vue&type=style&index=0&id=5b8d5c47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8d5c47",
  null
  
)

export default component.exports